import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import CloseIcon from '@material-ui/icons/Close';

import moment from 'moment'

import api from "../../../api/backend"
import confirm from '../../confirm'

const DialogTitle = withStyles(theme => ({
    root: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit * 2,
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing.unit,
        top: theme.spacing.unit,
        color: theme.palette.grey[500],
    },
}))(props => {
    const { children, classes, onClose } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root}>
            <Typography variant="title">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing.unit * 2,
    },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
    root: {
        borderTop: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit,
    },
}))(MuiDialogActions);

class Editor extends Component {
    state = {
        open: false, year: '', department: '', subjectId: '', deactivated: false, instructor: [], title: '', numberOfMonth: 0, noOfStudents: 0, price: 0, description: ''
        , instructors: [], departments: []
    };

    getInstructor = () => {
        api.getInstructor().then(([response, json]) => {
            if (response.status === 200) {
                this.setState({ instructors: json })
            }
        }).catch(() => { })
    }

    getDepartments = () => {
        api.getDepartments().then(([response, json]) => {
            if (response.status === 200) {
                this.setState({ departments: json })
            }
        }).catch(() => { })
    }

    filterSubject = () => {
        const { department, departments } = this.state;
        if (department) {
            const found = departments.find((element) => {
                return element.id === department
            })

            if (found) {
                return found.subjects
            } else {
                return []
            }
        } else {
            return []
        }
    }

    handleClickOpen = () => {
        this.getDepartments();
        this.getInstructor();
        this.setState({ open: true });
    }

    handleClose = () => {
        this.setState({ open: false });
    }

    updateCourse = () => {
        const { year, department, subjectId, deactivated, instructor, title, numberOfMonth, noOfStudents, price, description } = this.state
        api.updateCourse(this.props.course.id, { year, department, subjectId, deactivated, instructor, title, numberOfMonth, noOfStudents, price, description }).then(([response, json]) => {
            if (response.status === 200) {
                this.setState({ open: false })
                if (this.props.onUpdateCompleted) {
                    this.props.onUpdateCompleted()
                }
            } else {
                console.error('ไม่สามารถสร้างคอร์สเรียนได้')
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }

    deleteCourse = () => {
        const { course } = this.props
        confirm(`ต้องการลบคอร์ส '${course.title}' ใช่หรือไม่?`).then(
            (result) => {
                api.deleteCourse(course.id).then(([response, json]) => {
                    if (response.status === 200) {
                        this.setState({ open: false })
                        if (this.props.onUpdateCompleted) {
                            this.props.onUpdateCompleted()
                        }
                    } else {
                        console.error('ไม่สามารถลบคอร์สเรียนได้')
                    }
                }).catch(() => {
                    console.error('ไม่สามารถเชื่อมต่อ service ได้')
                })
            },
            (result) => { }
        )

    }

    componentWillMount() {
        const { year, subjectId, deactivated, instructor, title, numberOfMonth, noOfStudents, price, description } = this.props.course
        const { departmentId } = this.props.subject
        this.setState({ year, department: departmentId, deactivated, subjectId, instructor, title, numberOfMonth, noOfStudents, price, description })
    }

    componentDidMount() {

    }

    render() {
        const { year, department, subjectId, deactivated, instructor, title, numberOfMonth, noOfStudents, price, description, instructors, departments } = this.state

        return (<React.Fragment>
            <IconButton aria-label="Edit" size="small" onClick={this.handleClickOpen}>
                <EditIcon />
            </IconButton>
            <IconButton aria-label="Delete" size="small" onClick={this.deleteCourse}>
                <DeleteIcon />
            </IconButton>
            <Dialog
                open={this.state.open}
                onClose={this.handleClose}
                fullWidth
                maxWidth="md"
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">แก้ไขคอร์สเรียน</DialogTitle>
                <DialogContent>
                    <Grid container spacing={24} >
                        <Grid item xs={6}>
                            <FormControl style={{ minWidth: 240 }} fullWidth>
                                <InputLabel htmlFor="demo-controlled-open-select">ชื่อกลุ่มวิชา</InputLabel>
                                <Select
                                    value={department}
                                    onChange={(event) => { this.setState({ department: event.target.value }) }}
                                    inputProps={{
                                        name: 'department',
                                        id: 'department-simple',
                                    }}
                                >
                                    <MenuItem value="">
                                        <em>กรุณาเลือก</em>
                                    </MenuItem>
                                    {departments.map(department => (
                                        <MenuItem key={department.id} value={department.id}>{department.title}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl style={{ minWidth: 240 }} fullWidth>
                                <InputLabel htmlFor="demo-controlled-open-select">ชื่อวิชา</InputLabel>
                                <Select
                                    value={subjectId}
                                    onChange={(event) => { this.setState({ subjectId: event.target.value }) }}
                                    inputProps={{
                                        name: 'subject',
                                        id: 'subject-simple',
                                    }}
                                >
                                    <MenuItem value="">
                                        <em>กรุณาเลือก</em>
                                    </MenuItem>
                                    {
                                        this.filterSubject().map(subject => (
                                            <MenuItem key={subject.id} value={subject.id}>{subject.title}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl style={{ minWidth: 240 }} fullWidth>
                                <InputLabel htmlFor="demo-controlled-open-select">ปีการศึกษา</InputLabel>
                                <Select
                                    value={year}
                                    onChange={(event) => { this.setState({ year: event.target.value }) }}
                                    inputProps={{
                                        name: 'year',
                                        id: 'year-simple',
                                    }}
                                >
                                    <MenuItem value="">
                                        <em>กรุณาเลือก</em>
                                    </MenuItem>
                                    <MenuItem value={2562}>2562</MenuItem>
                                    <MenuItem value={2563}>2563</MenuItem>
                                    <MenuItem value={2564}>2564</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl style={{ minWidth: 240 }} fullWidth>
                                <InputLabel htmlFor="demo-controlled-open-select">อาจารย์ผู้สอน</InputLabel>
                                <Select
                                    value={instructor}
                                    onChange={(event) => { this.setState({ instructor: event.target.value }) }}
                                    inputProps={{
                                        name: 'instructor',
                                        id: 'instructor-simple',
                                    }}
                                >
                                    <MenuItem value="">
                                        <em>กรุณาเลือก</em>
                                    </MenuItem>
                                    {instructors.map(instructor => (
                                        <MenuItem key={instructor.id} value={`${instructor.userName}`}>{instructor.firstName} {instructor.lastName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="title"
                                name="title"
                                label="ชื่อคอร์ส"
                                fullWidth
                                value={title}
                                onChange={(event) => { this.setState({ title: event.target.value }) }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                required
                                id="numberOfMonth"
                                name="numberOfMonth"
                                label="จำนวนเดือนที่สามารถเรียนได้"
                                type="number"
                                fullWidth
                                value={numberOfMonth}
                                onChange={(event) => { this.setState({ numberOfMonth: event.target.value }) }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                required
                                id="noOfStudents"
                                name="noOfStudents"
                                label="จำนวนนักเรียน"
                                type="number"
                                fullWidth
                                value={noOfStudents}
                                onChange={(event) => { this.setState({ noOfStudents: event.target.value }) }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                required
                                id="price"
                                name="price"
                                label="ราคา"
                                type="number"
                                fullWidth
                                value={price}
                                onChange={(event) => { this.setState({ price: event.target.value }) }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="description"
                                name="description"
                                label="รายละเอียด"
                                fullWidth
                                multiline
                                rows={6}
                                value={description}
                                onChange={(event) => { this.setState({ description: event.target.value }) }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl style={{ minWidth: 240 }} fullWidth>
                                <InputLabel htmlFor="demo-controlled-open-select">สถานะ</InputLabel>
                                <Select
                                    value={deactivated}
                                    onChange={(event) => { this.setState({ deactivated: event.target.value }) }}
                                    inputProps={{
                                        name: 'deactivated',
                                        id: 'deactivated-simple',
                                    }}
                                >
                                    <MenuItem value={false}>ใช้งาน</MenuItem>
                                    <MenuItem value={true}>ไม่ได้ใช้งาน</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                        ยกเลิก
            </Button>
                    <Button onClick={this.updateCourse} color="primary">
                        บันทึก
            </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
        );
    }
}

export default Editor;